import { Navigate } from 'react-router-dom'

/** Legacy Lab SurveillanceBeta route — merged into `/surveillance`. */
export function SurveillanceBetaPage() {
  return <Navigate to="/surveillance" replace />
}
